export function xRayNoneAction() {
  const { t } = useI18n();

  return {
    getTitle: () => t('components.xeokit_viewer.context_menu.x_ray_none') || 'X-Ray None',
    getEnabled: (context) => {
      return context.viewer.scene.numXRayedObjects > 0;
    },
    doAction: (context) => {
      const xrayedObjectIds = context.viewer.scene.xrayedObjectIds;
      context.viewer.scene.setObjectsPickable(xrayedObjectIds, true);
      context.viewer.scene.setObjectsXRayed(xrayedObjectIds, false);
    },
  };
}
